
 let appArr=[
  {id:1,webName:'ASO乐榜',appUrl:'http://veryaso.com',icpName:'闽ICP备18007063号-1'},
  {id:2,webName:'QuickAppShop',appUrl:'http://quickappshop.com',icpName:'闽ICP备18007063号-2'},
  {id:3,webName:'久久数据大师',appUrl:'http://99api.com',icpName:'闽ICP备18007063号-3'},
  {id:4,webName:'6bqb后台管理',appUrl:'http://6bqb.com',icpName:'闽ICP备18007063号-4'},
  {id:5,webName:'6bqb后台管理',appUrl:'http://6bqb.cn',icpName:'闽ICP备18007063号-5'},
  {id:6,webName:'厦门乐榜',appUrl:'http://xmlebang.top',icpName:'闽ICP备18007063号-6'},
  {id:7,webName:'厦门乐榜网络科技',appUrl:'http://xmlebang.com',icpName:'闽ICP备18007063号-7'},
  {id:8,webName:'99数据',appUrl:'http://api99.cn',icpName:'闽ICP备18007063号-8'},
  {id:9,webName:'乐榜科技',appUrl:'http://xmlebang.ltd',icpName:'闽ICP备18007063号-9'},
  {id:10,webName:'乐榜城市',appUrl:'http://lbsupercity.com',icpName:'闽ICP备18007063号-10'},
  {id:11,webName:'智慧城市',appUrl:'http://lbsupercity.cn',icpName:'闽ICP备18007063号-17'},
  {id:12,webName:'99乐榜数据',appUrl:'http://99api.cn',icpName:'闽ICP备18007063号-12'},
  {id:13,webName:'超次元桌面',appUrl:'http://lbdesktop.com',icpName:'闽ICP备18007063号-13'},
  {id:14,webName:'厦门乐榜网络科技',appUrl:'http://zhongzhiguide.com',icpName:'闽ICP备18007063号-14'},
  {id:15,webName:'超级管家',appUrl:'http://sukeeper.com',icpName:'闽ICP备18007063号-15'},
];

let resUrl=window.location.href;
let secondUrl='';
let icpName='';
let webName='';
for(let key in appArr) {
  let secondUrl='www.'+appArr[key].appUrl.split('//')[1]
  if ( resUrl.indexOf(appArr[key].appUrl) !== -1 || resUrl.indexOf(secondUrl) !== -1) {
    icpName = appArr[key].icpName;
    webName = appArr[key].webName;
  }
}
 document.title=webName
export { icpName}



//////////////////
// WEBPACK FOOTER
// ./static/js/distinguishWeb.js
// module id = null
// module chunks = 